<template>
	<section class="border border-dark">
		<h4 class="title-form-group"><md-icon :icon="icon" /> {{title}} <slot name="append-title" /></h4>
		<slot></slot>
	</section>
</template>

<script>
// import MainLayout from '../layout/MainLayout.vue'
// import api from '../../../api.js'

export default {
	props: {
		title: {
			type : String,
			required: false,
			default:'',
		},
		icon: {
			type : String,
			required: false,
			default:'',
		},
	},
	components: {  },
	data(){
		return {
		}
	},
	methods:{},
	mounted(){
	}
}
</script>

<style scoped>
	section {
		margin-top: 10px;
		margin-bottom: 20px;
		padding: 1em 1em .5em;
		position: relative;
		border-radius: 8px;
	}
	.icon {
		position: absolute;
		right: 0;
		left: 0;
		top: -25px;
		margin: auto;
		background: #fff;
	}
	h4{
		font-size: 1.5rem;
		position: absolute;
		top: -14px;
		left: 10px;
		background: #fff;
		padding: 0 10px;
	}
	/* Applies to devices with a maximum width of 600px */
	@media only screen and (max-width: 1200px) {
		.title-form-group{
			position: initial !important;
		}
	}
</style>
